'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('paysub', {
        url: '/paysub',
        template: '<paysub></paysub>'
    });
}



// WEBPACK FOOTER //
// ./client/app/paysub/paysub.routes.js